import { makeAutoObservable } from 'mobx'
import { uiStore } from 'shared/store/uiStore'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { DropdownCardsStore } from 'entities/Billing/ui/DropdownCards'
import { CombinedPriceInfoStore } from 'entities/Billing/ui/CombinedPriceInfo/store/combinedPriceInfoStore'
import { NumbersPath } from 'pages/settings/pages/numbers/route/numbersPath'
import { ManageNumbersStore } from 'pages/settings/pages/numbers/ui/ManageNumbers'

export class PaymentCommonStore {
  readonly dropdownCardsStore: DropdownCardsStore
  readonly manageNumbersStore: ManageNumbersStore
  readonly combinedPriceInfoStore: CombinedPriceInfoStore

  private _paymentError = false
  private _noAvailableError = false

  constructor(private _refresh: () => void, private _entities: IEntitiesStore) {
    this.dropdownCardsStore = new DropdownCardsStore(this._entities.billingStore)
    this.manageNumbersStore = new ManageNumbersStore(0, () => {}, this._entities)

    this.combinedPriceInfoStore = new CombinedPriceInfoStore({
      entities: this._entities,
    })

    makeAutoObservable(this)
    this.init()
  }

  get numbersPriceInfoStore() {
    return this.combinedPriceInfoStore.numbersPriceInfoStore
  }

  get isFirstNumber() {
    return this._entities.numbersStore.numbers.length === 0
  }

  get paymentError() {
    return this._paymentError
  }

  get noAvailableError() {
    return this._noAvailableError
  }

  get licensesCount() {
    return this.manageNumbersStore.licensesCount
  }

  get isLoadingPriceInfo() {
    return this.combinedPriceInfoStore.isLoading
  }

  init = async () => {
    await this._entities.subscriptionStore.initPromise
  }

  setPaymentError = (error: boolean) => {
    this._paymentError = error
    this.dropdownCardsStore.setPaymentError('Please select a different card')
  }

  setNoAvailableError = (error: boolean) => {
    this._noAvailableError = error
  }

  clearError = () => {
    this._paymentError = false
    this._noAvailableError = false
    this.dropdownCardsStore.clearPaymentError()
  }

  chooseNumberHandler = () => {
    this.setNoAvailableError(false)
    this._refresh()

    uiStore.changeRoute({ path: `/${NumbersPath.buyNumber.stepsRoot}` })
  }

  fetchPriceData = (requiredNumbers: number, requiredSeats = 0) => {
    this.combinedPriceInfoStore.updatePriceData(requiredNumbers, requiredSeats)
  }
}
